module.exports = __webpack_public_path__ + "static/media/permissions1.e39aa363.jpg";